export default __webpack_public_path__ + "img/d84674807dd396762481c90bf0c1d079.svg";